import variantFragment from '@containers/ProductDetailContainer/queries/fragVariant.graphql';

import { ICallbackParameters } from '../model';

export const updateVariantCache = ({
  products,
  cache,
  productId,
}: ICallbackParameters & { productId: string | number }) => {
  const data = cache.readFragment({
    fragment: variantFragment,
    id: `Variant:${productId}`,
  });
  const wishlisted = products.includes(productId.toString());

  const updatedVariantFragment = { ...data, wishlisted };

  cache.writeFragment({
    fragment: variantFragment,
    id: `Variant:${productId}`,
    data: updatedVariantFragment,
  });

  return data;
};
